import * as XLSX from 'xlsx';

export const exportToExcel = (data, fileName) => {
  const worksheet = XLSX.utils.json_to_sheet(
    data.flatMap(employee => 
      employee.sessions.map((session, index) => ({
        'Employee Name': employee.employeeName, // Employee name
        'Session': index + 1, // Session number
        'Login Time': session.loginTime, // Login time
        'Logout Time': session.logoutTime, // Logout time
        'Session Duration': session.duration, // Session duration
      }))
    )
  );

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Employee Report');
  
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
